import { render, staticRenderFns } from "./MultilanguageEditForm.vue?vue&type=template&id=1933b892"
import script from "./MultilanguageEditForm.vue?vue&type=script&lang=js"
export * from "./MultilanguageEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports